import React, { Fragment } from "react";
import './ReportFooter.scss';

interface IReportFooterProps {
    name?: string;
    location?: string;
    practice?: string;
    description?: string;
    designedByName?: string;
    designedByDate?: string;
}
export const ReportFooter = (props: IReportFooterProps) => {
    return (
        <Fragment>
            <div className="row report-footer">
                <div className="col report-footer-left" tabIndex={8}>
                    <div className="row">
                        <span className='col footer-label'>Project Name:</span>
                        <span className='col blank-underline'>{props.name}</span>
                    </div>
                    <div className="row">
                        <span className='col footer-label'>Location:</span>
                        <span className='col blank-underline'>{props.location}</span>
                    </div>
                    <div className="row">
                        <span className='col footer-label'>Practice:</span>
                        <span className='col blank-underline'>{props.practice}</span>
                    </div>
                    <div className="row">
                        <span className='col footer-label'>Description:</span>
                        <span className='col blank-underline'>{props.description}</span>
                    </div>
                </div>
                <div className='col report-footer-combined-right' tabIndex={9}>
                    <div className="row">
                        <span className='col footer-label'>Designed By:</span>
                        <span className='col designed-by-name'>{props.designedByName}</span>
                        <span className='col footer-label footer-label-date'>Date:</span>
                        <span className='col blank-underline-date'>{props.designedByDate}</span>
                    </div>
                    <div className="row">
                        <span className='col footer-label'>Checked By:</span>
                        <span className='col blank-underline'></span>
                        <span className='col footer-label footer-label-date'>Date:</span>
                        <span className='col blank-underline-date'></span>
                    </div>
                    <div className="row">
                        <span className='col footer-label'>Approved By:</span>
                        <span className='col blank-underline'></span>
                        <span className='col footer-label footer-label-date'>Date:</span>
                        <span className='col blank-underline-date'></span>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}